import { Card, Table, Button, Typography, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import TableTitle from '@/components/Elements/Heading/TableTitle';
import { useGetAnnualAssessmentsQuery } from '@/pages/tax/apis/annualAssessmentAPI';
import { formatSecondaryDate } from '@/utils/commonUtils';

const STATUS_MAP: Record<string, { color: string; label: string }> = {
  pending: { color: 'orange', label: 'Pending' },
  reviewed: { color: 'blue', label: 'Reviewed' },
  completed: { color: 'green', label: 'Completed' },
};

const columns: any = [
  {
    title: <TableTitle>Tax Year</TableTitle>,
    dataIndex: 'details',
    key: 'taxFinancialYear',
    align: 'center',
    render: (details: any) => {
      const year = details?.tax_financial_year;
      return year ? (
        <Tag color="blue">{`FY${String(year).slice(-2)}`}</Tag>
      ) : (
        <Typography.Text type="secondary">—</Typography.Text>
      );
    },
  },
  {
    title: <TableTitle>Submitted</TableTitle>,
    dataIndex: 'created_at',
    key: 'created_at',
    align: 'center',
    sorter: (a: { created_at: string }, b: { created_at: string }) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
    defaultSortOrder: 'descend',
    render: (date: string) => (
      <Typography.Text>
        {date ? formatSecondaryDate(date) : '—'}
      </Typography.Text>
    ),
  },
  {
    title: <TableTitle>Status</TableTitle>,
    dataIndex: 'status',
    key: 'status',
    align: 'center',
    render: (status: string) => {
      const s = STATUS_MAP[status] ?? {
        color: 'default',
        label: 'Submitted',
      };
      return <Tag color={s.color}>{s.label}</Tag>;
    },
  },
];

const PreLodgementTable = () => {
  const navigate = useNavigate();
  const { data: annualAssessments, isLoading } = useGetAnnualAssessmentsQuery();

  return (
    <Card
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          Pre-lodgement Checklist
        </Typography.Title>
      }
      extra={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/tax/tax-returns/pre-lodgement-checklist')}
        >
          Submit Checklist
        </Button>
      }
    >
      <Table
        columns={columns}
        dataSource={annualAssessments?.data ?? []}
        rowKey="id"
        loading={isLoading}
        scroll={{ x: 'max-content' }}
        pagination={{
          defaultPageSize: 5,
          showSizeChanger: false,
          showTotal: (total) => `${total} submission${total !== 1 ? 's' : ''}`,
        }}
        locale={{
          emptyText: 'No submissions yet. Submit your first checklist above.',
        }}
      />
    </Card>
  );
};

export default PreLodgementTable;
